module.exports = __webpack_public_path__ + "img/1.8da7da03.jpg";